export default {};
export const Duplex = {};
export const PassThrough = {};
export const Readable = {};
export const Stream = {};
export const Transform = {};
export const Writable = {};
export const _isArrayBufferView = {};
export const _isUint8Array = {};
export const _uint8ArrayToBuffer = {};
export const addAbortSignal = {};
export const compose = {};
export const destroy = {};
export const duplexPair = {};
export const eos = {};
export const finished = {};
export const getDefaultHighWaterMark = {};
export const isDestroyed = {};
export const isDisturbed = {};
export const isErrored = {};
export const isReadable = {};
export const isWritable = {};
export const pipeline = {};
export const promises = {};
export const setDefaultHighWaterMark = {};